import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Drawer from "../Drawer";
import { useGetDocumentDetails } from "../../custom-hooks/queries";
import { setDrawer } from "../../redux-store/features/layoutSlice";

/**
 * Document Library drawer for My Vendors library-request badges.
 * Mirrors RFILibrary / DocumentLibrary drawer wiring; may be replaced later.
 */
export default function MyVendorsLibraryDrawer({ documentId = null }) {
  const dispatch = useDispatch();
  const isDrawerOpen = useSelector((state) => state.layout.drawerOpen);

  const {
    data: drawerData,
    isPending: drawerLoading,
    isSuccess: drawerIsSuccess,
    refetch,
  } = useGetDocumentDetails(documentId);

  useEffect(() => {
    if (!documentId && isDrawerOpen) {
      dispatch(setDrawer(false));
    }
  }, [documentId, isDrawerOpen, dispatch]);

  if (!isDrawerOpen || !documentId) return null;

  return (
    <Drawer
      docId={drawerData?.document_id ?? documentId}
      docType={drawerData?.document_type ?? drawerData?.entity_type}
      documents={drawerData}
      drawerLoading={drawerLoading}
      drawerIsSuccess={drawerIsSuccess}
      refetch={refetch}
    />
  );
}
